const geoimg = {
	install(Vue, options) {

		Vue.prototype.$geoimg = {
			getMeta: function(image){
				if (typeof image === 'string') {
					const src = image;
					image = new Image();
					image.src = src;
				}
				else {
					return Promise.reject();
				}

				const promise = new Promise((resolve, reject) => {
					if (image.naturalWidth) {
						resolve({width: image.naturalWidth, height: image.naturalHeight});
					} else if (image.complete) {
						reject(image);
					} else {
						image.addEventListener('load', fullfill);
						image.addEventListener('error', fullfill);
					}
					function fullfill() {
						if (image.naturalWidth) {
							resolve({width: image.naturalWidth, height: image.naturalHeight});
						} else {
							reject(image);
						}
						image.removeEventListener('load', fullfill);
						image.removeEventListener('error', fullfill);
					}
				});
				promise.image = image;
				return promise;
			}
		}

	}
};

export default geoimg;